<!--
<div class="cart">
  <a routerLink="/cart"></a>
  <i class="icon-bag"></i>
  <span class="count">{{items.length}}</span>
  <span class="subtotal">{{ total | currency }}</span>
  <div class="toolbar-dropdown">
    <div *ngIf="items.length; else noItemsInCart">
      <div *ngFor="let item of items" class="dropdown-product-item">
        <span class="dropdown-product-remove" (click)="onRemoveItem($event, item)">
          <i class="icon-cross"></i>
        </span>
        <a class="dropdown-product-thumb" [routerLink]="['/products', item.product.id]">
          <img [src]="item?.product?.imageURLs[0]" alt="{{item?.product?.name}}">
        </a>
        <div class="dropdown-product-info">
          <a class="dropdown-product-title" [routerLink]="['/products', item.product.id]">{{item.product.name}}</a>
          <span class="dropdown-product-details">{{item.price}} x <span><app-price [product]="item.product"></app-price></span></span>
        </div>
      </div>
    </div>
    <ng-template #noItemsInCart>
      <div><p>
        There are no items in your cart..
      </p></div>
    </ng-template>
    <div class="toolbar-dropdown-group">
      <div class="column">
        <span class="text-lg">Total:</span>
      </div>
      <div class="column text-right">
        <span class="text-lg text-medium" [innerHTML]="total | currency">&nbsp;</span>
      </div>
    </div>
    <div class="toolbar-dropdown-group">
      <div class="column">
        <a class="btn btn-sm btn-block btn-secondary" routerLink="/cart">View Cart</a>
      </div>
      <div class="column">
        <a class="btn btn-sm btn-block btn-success" routerLink="/checkout">Checkout</a>
      </div>
    </div>
  </div>
</div>
-->


<!--<div class="cart relative">-->
<!--  <a routerLink="/cart" class="flex items-center space-x-2 group">-->
<!--    <span class="icon-bag text-gray-600 hover:text-gold transition-colors duration-300">-->
<!--      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">-->
<!--        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>-->
<!--      </svg>-->
<!--    </span>-->
<!--    <span class="count text-xs bg-gold text-white rounded-full px-2 py-1 font-medium transition-all duration-300 group-hover:bg-yellow-600">{{ items.length }}</span>-->
<!--    <span class="subtotal text-sm font-serif text-gray-700 hidden sm:inline">{{ total | currency:'MAD' }}</span>-->
<!--  </a>-->

<!--  <div class="toolbar-dropdown absolute right-0 mt-2 w-80 bg-white text-gray-900 rounded-lg shadow-lg py-2 z-50 hidden group-hover:block">-->
<!--    <div *ngIf="items.length; else noItemsInCart" class="max-h-64 overflow-y-auto">-->
<!--      <div *ngFor="let item of items" class="dropdown-product-item flex items-center p-2 hover:bg-gray-50 transition-colors duration-300">-->
<!--        <span class="dropdown-product-remove text-red-600 hover:text-red-800 cursor-pointer" (click)="onRemoveItem($event, item)">-->
<!--          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">-->
<!--            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>-->
<!--          </svg>-->
<!--        </span>-->
<!--        <a class="dropdown-product-thumb w-12 h-12 ml-2" [routerLink]="['/products', item.product.id]">-->
<!--          <img [src]="item?.product?.imageURLs[0]" alt="{{item?.product?.name}}" class="w-full h-full object-cover rounded">-->
<!--        </a>-->
<!--        <div class="dropdown-product-info flex-1 ml-3">-->
<!--          <a class="dropdown-product-title text-sm font-serif text-gray-900 hover:text-gold transition-colors duration-300" [routerLink]="['/products', item.product.id]">{{ item.product.name }}</a>-->
<!--          <span class="dropdown-product-details text-xs text-gray-600">{{ item.quantity }} x <app-price [product]="item.product"></app-price></span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <ng-template #noItemsInCart>-->
<!--      <div class="p-4 text-center">-->
<!--        <p class="text-sm text-gray-600">There are no items in your cart..</p>-->
<!--      </div>-->
<!--    </ng-template>-->
<!--    <div class="toolbar-dropdown-group flex justify-between items-center px-4 py-2 border-t border-gray-200">-->
<!--      <div class="column">-->
<!--        <span class="text-lg font-serif text-gray-900">Total:</span>-->
<!--      </div>-->
<!--      <div class="column text-right">-->
<!--        <span class="text-lg font-serif text-gold" [innerHTML]="total | currency:'MAD'"></span>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="toolbar-dropdown-group flex space-x-2 px-4 py-2">-->
<!--      <a routerLink="/cart" class="flex-1 text-center bg-gray-200 text-gray-800 font-serif py-2 rounded hover:bg-gray-300 transition-colors duration-300">-->
<!--        View Cart-->
<!--      </a>-->
<!--      <a routerLink="/checkout" class="flex-1 text-center bg-gold text-white font-serif py-2 rounded hover:bg-yellow-600 transition-colors duration-300">-->
<!--        Checkout-->
<!--      </a>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->


<div class="cart relative" (mouseenter)="onMouseEnterCart()" (mouseleave)="onMouseLeaveCart()">
  <a routerLink="/cart" class="flex items-center space-x-2 group">
    <span class="icon-bag text-gray-600 hover:text-gold transition-colors duration-300">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
      </svg>
    </span>
    <span class="count -ml-4 text-[11px] bg-black text-gold rounded-sm w-5 h-5 flex items-center justify-center font-bold ring-1 ring-gold/30">{{ itemsCount }}</span>
  </a>

  <!-- <div class="toolbar-dropdown absolute right-0 mt-2 w-80 max-w-[90vw] bg-white text-gray-900 rounded-lg shadow-lg py-2 z-50"
       [ngClass]="{'hidden': !showDropdown, 'block': showDropdown}"
       (mouseenter)="onMouseEnterDropdown()"
       (mouseleave)="onMouseLeaveDropdown()">
    <div *ngIf="items.length; else noItemsInCart" class="max-h-64 overflow-y-auto">
      <div *ngFor="let item of items" class="dropdown-product-item flex items-center p-2 hover:bg-gray-50 transition-colors duration-300">
        <span class="dropdown-product-remove text-red-600 hover:text-red-800 cursor-pointer" (click)="onRemoveItem($event, item)">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </span>
        <a class="dropdown-product-thumb w-12 h-12 ml-2" [routerLink]="['/products', item.product.id]">
          <img [src]="item?.product?.imageURLs[0]" alt="{{item?.product?.name}}" class="w-full h-full object-cover rounded">
        </a>
        <div class="dropdown-product-info flex-1 ml-3 truncate">
          <a class="dropdown-product-title text-sm font-serif text-gray-900 hover:text-gold transition-colors duration-300 truncate block" [routerLink]="['/products', item.product.id]">{{ item.product.name }}</a>
          <span class="dropdown-product-details text-xs text-gray-600">{{ item.quantity }} x <app-price [product]="item.product"></app-price></span>
        </div>
      </div>
    </div>
    <ng-template #noItemsInCart>
      <div class="p-4 text-center">
        <p class="text-sm text-gray-600">There are no items in your cart..</p>
      </div>
    </ng-template>
    <div class="toolbar-dropdown-group flex justify-between items-center px-4 py-2 border-t border-gray-200">
      <div class="column">
        <span class="text-lg font-serif text-gray-900">Total:</span>
      </div>
      <div class="column text-right">
        <span class="text-lg font-serif text-gold" [innerHTML]="total | currency:'MAD'"></span>
      </div>
    </div>
    <div class="toolbar-dropdown-group flex space-x-2 px-4 py-2">
      <a routerLink="/cart" class="flex-1 text-center bg-gray-200 text-gray-800 font-serif py-2 rounded hover:bg-gray-300 transition-colors duration-300">
        View Cart
      </a>
      <a routerLink="/checkout" class="flex-1 text-center bg-gold text-white font-serif py-2 rounded hover:bg-yellow-600 transition-colors duration-300">
        Checkout
      </a>
    </div>
  </div> -->
</div>
